function stubFalse() {
  return false;
}

var stubFalse_1 = stubFalse;
export { stubFalse_1 as s };